module.exports = __webpack_public_path__ + "static/iconjar2-9-f8c52cb78de9843914513cd418668bb3.mp4";